import Axios from 'axios';

async function getEnv() {
    try {
        let resposta = await Axios.get(process.env.VUE_APP_BASE_URL + "env.json");
        return resposta.data;
    } catch (err) {
        return {};
    }
}

const appBaseUrl = process.env.VUE_APP_BASE_URL;

/**
 * Monta a URL base para o sistema
 * @param {string} url 
 * @returns {string}
 */
function baseUrl(url = "") {
    // se começar com barra, remove
    if (url.startsWith("/")) {
        url = url.substring(1);
    }
    return appBaseUrl + url;
}

export default { getEnv, baseUrl }
